import createCandyRackClient from '../client';
import getTranslationsQuery from '../queries/getTranslationsQuery';
import getLanguage from '../../shared/utils/getLanguage';
import { logError } from '../../shared/utils/logging';
import transformTranslationsMetaobjectData from '../../utils/transformTranslationsMetaobjectData';
import MetaObjectsQueryData from '../types/MetaObjectsQueryData';

// Function that queries metaobject data from Storefront API - or returns null
const getTranslationsMetaobject = async (
  token: string,
  metaObjectType: string,
) => {
  const storefrontApiClient = createCandyRackClient(token);

  // Storefront client returns null if no token was provided
  if (!storefrontApiClient) {
    return null;
  }

  const {
    data,
    errors,
    // @ts-ignore
  } = await storefrontApiClient.request(
    getTranslationsQuery(metaObjectType, getLanguage().toUpperCase()),
  );

  // In case of an error we return null
  if (errors) {
    logError(`Storefront API failed, using fallback, ${errors}`);
    return null;
  }

  // Check for empty response and use fallback
  if (
    !(data as MetaObjectsQueryData).metaobjects ||
    (data as MetaObjectsQueryData).metaobjects.edges.length === 0
  ) {
    return null;
  }

  // Transformed metaobject data
  return transformTranslationsMetaobjectData(
    (data as MetaObjectsQueryData).metaobjects.edges[0].node.fields,
  );
};

export default getTranslationsMetaobject;
